import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { Box, Tooltip, Text } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import type { MonthlyPaymentInputProps } from '../types';
import { getFieldValueByCalculator } from '../utils';

const PrincipalAndInterestInput = (
  props: MonthlyPaymentInputProps
): JSX.Element => {
  const {
    value,
    label = 'Principal and Interest',
    tooltip = 'The portions of the monthly payment that reduce the amount you owe (principal) and the cost of borrowing (interest).',
  } = props;

  const currencyValue = _.isNil(value) ? '' : num.formatCurrency(value);

  const tooltipLabel = <Text size="small">{label}</Text>;

  return (
    <Box
      display="flex"
      flexDirection={{ desktop: 'column', mobile: 'row' }}
      justifyContent="space-between"
    >
      <Box>
        {/* @ts-ignore - ignore type error for label */}
        <Tooltip label={tooltipLabel} content={tooltip} />
      </Box>
      <Box>
        <Text size="small" bold>
          {currencyValue}
        </Text>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state, ownProps: MonthlyPaymentInputProps) => {
  const { calculator } = ownProps;
  return {
    value: getFieldValueByCalculator(state, calculator, 'principalAndInterest'),
  };
};

export default connect(mapStateToProps)(PrincipalAndInterestInput);
